import styled from 'styled-components';

import { theme } from '../GlobalStyles';

const PartnerLayout = styled.div`
  margin: 0 auto 2rem;
  display: flex;
  flex-direction: column;

  .banner {
    padding-bottom: 52.356021%;
    background-size: cover;
    background-position: center;
    position: relative;
  }
  .logo {
    max-height: 4.375rem;
    max-width: 4.375rem;
    display: block;
    margin: 0 auto;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);

    background: #fff;
    padding: 1rem;
    border-radius: 100%;
    position: absolute;
    left: 14px;
    bottom: 1rem;
  }
  .merchant-title {
    text-align: center;
    border-bottom: 1px solid #ddd;
    padding-bottom: 1rem;
    margin-bottom: 2rem;
  }
  .merchant-meta .banner {
    padding-bottom: 52.356021%;
    margin-left: -1rem;
    margin-right: -1rem;
  }
  .merchant-info {
    padding-bottom: 1rem;
    margin-bottom: 1rem;
    text-align: center;
    display: flex;
    justify-content: center;
  }
  .merchant-info a {
    width: 1.5rem;
    height: 1.5rem;
    margin: 0 0.5rem;
  }
  .merchant-detail .merchant-detail-main,
  .merchant-title {
    display: none;
  }
  .outlet {
    border-bottom: 1px solid #eee;
    margin-bottom: 1.5rem;
    h5 {
      margin: 0 0 0.2rem;
      font-size: 1.09375rem;
    }
  }
  .outlet-address {
    display: block;
    margin-bottom: 0.5rem;
    color: ${theme.colors.grey};
    font-size: 1rem;
    font-weight: 400;
  }
  .details p {
    color: ${theme.colors.grey};
    margin-top: 0;
  }
  .tnc ul,
  .lp-award ul {
    padding-left: 1rem;
    margin-left: 0;
  }
  .tnc li,
  .lp-award li {
    font-size: 1rem;
  }
  .lp-award p {
    font-size: 1rem;
  }
  .lp-award li {
    margin-bottom: 0.75rem;
    font-size: 0.875rem;
  }
  .tnc p {
    font-size: 0.875rem;
  }
  .outlets-see-more,
  .outlets-see-more:hover {
    font-size: 1rem;
    color: ${theme.colors.purple};
  }
  .radio-list {
    display: inline-flex;
    flex-direction: column;
    margin-bottom: 3rem;
  }
  .radio {
    margin-bottom: 1.5rem;
    display: inline-block;
  }
  .radio-text {
    flex: 1;
    vertical-align: middle;
  }
  .radio-text::before {
    content: '';
    width: 1.5rem;
    height: 1.5rem;
    display: inline-block;
    border-radius: 100%;
    border: 0.125rem solid ${theme.colors.purple};
    background: ${theme.colors.purple};
    box-shadow: 0 0 0 0.625rem #fff inset;
    transition: box-shadow 150ms ease;
    margin-right: 0.5rem;
    vertical-align: -0.3em;
  }
  .radio-input:checked + .radio-text::before {
    box-shadow: 0 0 0 0.3125rem #fff inset;
  }
  .radio-input {
    position: absolute;
    z-index: -1;
    opacity: 0;
    appearance: none;
  }
  .radio-input[disabled] + .radio-text,
  .radio-input[disabled] + .radio-text strong {
    color: #ccc;
  }
  .radio-input[disabled] + .radio-text::before {
    border-color: #ccc;
  }
  .modal-body {
    background: #f6f4f9;
    border-radius: 0.5rem;
  }
  .error {
    text-align: center;
    position: inherit;
  }
  .exchange-section {
    border: 1px solid ${theme.colors.purpleLight};
    border-radius: 0.5rem;
    padding: 1rem;
    margin: 1rem 0;
    text-align: center;
  }
  .exchange-unit-linkpoints {
    color: ${theme.colors.purple};
    font-weight: normal;
  }
  .exchange-figure {
    display: flex;
    align-items: center;
    justify-content: space-around;
    margin-bottom: 3rem;
  }
  .exchange-direction {
    cursor: pointer;
    margin: 2rem 0;
    fill: ${theme.colors.purple};
    background: none;
    padding: 0 0.3125rem;
    flex-basis: 25%;
    max-width: 3.25rem;
    border: none;
    min-width: 0;
  }
  .exchange-direction:hover {
    background: transparent;
  }
  .exchange-direction:focus {
    outline: none;
  }
  .exchange-direction .icon-swap {
    display: none;
  }
  .exchange-direction:hover .icon-swap {
    display: block;
  }
  .exchange-direction:hover .icon-arrow {
    display: none;
  }
  .exchange-points {
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: space-between;
    img {
      margin: 0 0.5rem;
      width: 100%;
      max-width: 12.5rem;
    }
    h4 {
      margin-bottom: 0;
    }
  }
  .exchange-member-id,
  .exchange-unlink {
    font-size: 0.75rem;
    font-weight: normal;
    color: #666;
    margin-top: 0.25rem;
  }
  .exchange-unlink {
    color: ${theme.colors.purple};
    text-transform: capitalize;
    border-color: transparent;
    background-color: transparent;
    border-radius: 0;
    cursor: pointer;
  }
  .exchange-unlink:hover {
    text-decoration: underline;
  }
  button[disabled] {
    cursor: not-allowed;
    background: #ccc;
  }
  button[disabled]:hover {
    color: white;
  }

  ${theme.mediaQueries.below.small} {
    .outlets-table header {
      display: none;
    }
    .exchange-direction {
      transform: rotate(90deg);
    }
  }
  ${theme.mediaQueries.above.small} {
    flex-direction: row;
    margin-top: 2rem;

    .logo {
      max-width: 9.375rem;
      max-height: 9.375rem;
      position: static;
      padding: 0;
      border-radius: 0;
      background: transparent;
      box-shadow: none;
    }
    .merchant-meta .banner {
      background-image: none !important;
      padding-bottom: 0;
    }
    .merchant-meta .banner .merchant-banner {
      display: none;
      padding-bottom: 0;
    }
    .merchant-meta {
      width: 33%;
      padding: 0 3rem 0 0;
      margin-bottom: 2rem;
      font-size: 1rem;
    }
    .merchant-meta p {
      font-size: 1rem;
    }
    .merchant-detail {
      width: 66%;
    }
    .merchant-detail .merchant-detail-main,
    .merchant-title {
      display: block;
    }
    .partnerpage-banner {
      position: relative;
      padding-bottom: 52.356%;
    }
    .exchangepage-banner {
      position: relative;
      padding-bottom: 26%;
    }
    .outlets {
      display: flex;
      flex-wrap: wrap;
    }
    .outlet {
      flex: 0 0 calc(33% - 0.666rem);
      margin-left: 1rem;
      border: none;
    }
    .outlet:nth-child(3n + 1) {
      margin-left: 0;
    }
    .merchant-meta .issuance-holder {
      display: none;
    }
  }
`;

const Issuance = styled.div`
  line-height: 1.25;
  font-size: 1.75rem;
  padding: 2.625rem 1.75rem;
  text-align: center;
  font-weight: 500;
  border-bottom: 0.0625rem solid #ddd;
  .linkpointDescription {
    display: block;
    margin-top: 0.5rem;
    .highlight {
      color: ${theme.colors.purple};
      font-weight: 500;
    }
  }
  small {
    font-size: 1.25rem;
    margin-top: 0.5rem;
  }
`;

export { PartnerLayout, Issuance };
